import {JSX} from "react";

export default function HorizontalContainer(props: {children: JSX.Element[]}): JSX.Element {
    return <div style={{display:"flex"}}>
        {props.children}
    </div>;
}